import { FreemiumCategory, FreemiumField } from './types';

export const FREEMIUM_CATEGORIES_FIELDS: Record<string, FreemiumField> = {
  tenors: { id: 'tenors', displayName: 'Allowed number of tenors' },
  product_symbols: { id: 'product_symbols', displayName: 'Allowed product symbols' },
  delay: { id: 'delay', displayName: 'Delay (in minutes)' },
  range_days: { id: 'range_days', displayName: 'Range (days)' },
  period: { id: 'period', displayName: 'Period' },
  snapshot_periods: { id: 'snapshot_periods', displayName: 'Periods' },
  report_links: { id: 'report_links', displayName: 'Report Links' },
  report_link: { id: 'report_link', displayName: 'Report Link' },
  settlement_period: { id: 'settlement_period', displayName: 'Settlement Period' },
  products: { id: 'products', displayName: 'Allowed product symbols' },
};

export const NESTED_FREEMIUM_CATEGORIES_FIELDS: Record<string, FreemiumField> = {
  chart: {
    id: 'chart',
    displayName: 'Chart',
    fields: [
      FREEMIUM_CATEGORIES_FIELDS.products,
      FREEMIUM_CATEGORIES_FIELDS.tenors,
      FREEMIUM_CATEGORIES_FIELDS.delay,
      FREEMIUM_CATEGORIES_FIELDS.range_days,
    ],
  },
  settlement: {
    id: 'settlement',
    displayName: 'Settlement',
    fields: [
      FREEMIUM_CATEGORIES_FIELDS.products,
      FREEMIUM_CATEGORIES_FIELDS.tenors,
      FREEMIUM_CATEGORIES_FIELDS.delay,
      FREEMIUM_CATEGORIES_FIELDS.range_days,
    ],
  },
};

export const FREEMIUM_CATEGORIES: FreemiumCategory[] = [
  {
    id: 'tickers',
    title: 'Tickers',
    fields: [FREEMIUM_CATEGORIES_FIELDS.product_symbols, FREEMIUM_CATEGORIES_FIELDS.tenors, FREEMIUM_CATEGORIES_FIELDS.delay],
  },
  {
    id: 'charts',
    title: 'Charts',
    fields: [
      FREEMIUM_CATEGORIES_FIELDS.product_symbols,
      FREEMIUM_CATEGORIES_FIELDS.tenors,
      FREEMIUM_CATEGORIES_FIELDS.period,
      FREEMIUM_CATEGORIES_FIELDS.range_days,
    ],
  },
  {
    id: 'snapshots',
    title: 'Snapshots',
    fields: [
      FREEMIUM_CATEGORIES_FIELDS.product_symbols,
      FREEMIUM_CATEGORIES_FIELDS.tenors,
      FREEMIUM_CATEGORIES_FIELDS.snapshot_periods,
      FREEMIUM_CATEGORIES_FIELDS.range_days,
    ],
  },
  { id: 'research', title: 'Research', fields: [FREEMIUM_CATEGORIES_FIELDS.report_links] },
  /* The officials category isn't supported by the updateFreemiumData endpoint yet
 {
    id: 'the_officials',
    title: 'The Officials',
    fields: [
      NESTED_FREEMIUM_CATEGORIES_FIELDS.chart,
      NESTED_FREEMIUM_CATEGORIES_FIELDS.settlement,
      FREEMIUM_CATEGORIES_FIELDS.settlement_period,
      FREEMIUM_CATEGORIES_FIELDS.report_link,
    ],
    hasCustomPage: true,
    customPagePath: '/admin/freemium/officials-update',
  },*/
];

export enum snapshotPeriods {
  Unspecified = 'unspecified',
  Singapore_1630 = 'singapore_1630',
  London_1630 = 'london_1630',
  London_1930 = 'london_1930',
}

export enum settlementPeriods {
  Unspecified = 'unspecified',
  Singapore_1630 = 'singapore_1630',
  London_1630 = 'london_1630',
}

export const FIELD_DEFAULT_VALUES: Record<string, any> = {
  product_symbols: [],
  tenors: 1,
  delay: 1,
  range_days: 7,
  period: '1s',
  snapshotperiods: [snapshotPeriods.Unspecified],
  report_links: [],
  report_link: '',
  settlement_period: settlementPeriods.London_1630,
  settlement: {
    products: [],
    tenors: 1,
    delay: 1,
    range_days: 7,
  },
  chart: {
    products: [],
    tenors: 1,
    delay: 1,
    range_days: 7,
  },
};

export const OFFICIALS_FIELD_CONFIG = {
  settlement: ['products', 'tenors', 'delay', 'range_days'],
  chart: ['products', 'tenors', 'delay', 'range_days'],
  settlement_period: ['settlement_period'],
  report_link: ['report_link'],
};

export const FIELD_TO_TITLE_MAP = {
  settlement: 'Settlement',
  chart: 'Chart',
  settlement_period: 'Settlement Period',
  report_link: 'The Officials Report Link',
  product_symbols: 'Product Selection',
  tenors: 'Number of Tenors',
  delay: 'Delay (minutes)',
  range_days: 'Range (days)',
  period: 'Period',
  snapshot_periods: 'Periods',
  report_links: 'Report Links',
  products: 'Product Selection',
};

export const TITLE_TO_CATEGORY_MAP = {
  Settlement: 'settlement',
  Chart: 'chart',
  'Settlement Period': 'settlement_period',
  'Report Link': 'report_link',
};

export const PERIOD_OPTIONS = ['1s', '1m', '1h', '1d'];
